.column {
  --gutter: var(--space-4);
  max-width: calc(var(--column-max) + 2 * var(--gutter));
  padding-block: var(--space-5) calc(2 * var(--space-8));
  padding-inline: max(var(--gutter), env(safe-area-inset-left)) max(var(--gutter), env(safe-area-inset-right));
}

.column:has([data-column="larga"]) {
  max-width: calc(var(--column-wide) + 2 * var(--gutter));
}

@media (min-width: 720px) {
  .column {
    --gutter: var(--space-8);
  }
}

@media (min-width: 1200px) {
  .column {
    --gutter: calc(2 * var(--space-8));
  }
}

.open {
  --block: var(--space-8);
  display: flex;
  flex-direction: column;
  gap: var(--block);
  min-width: 0;
}

.open > section + section {
  margin-top: 0;
}

@media (max-width: 719px) {
  .open {
    --block: var(--space-6);
  }
}

.header {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
}

.titleRow {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.title {
  font: var(--text-large-title);
  letter-spacing: var(--tracking-large-title);
  color: var(--label);
  overflow-wrap: anywhere;
}

.header > p {
  max-width: 66ch;
  font: var(--text-callout);
  color: var(--label-2);
  text-wrap: pretty;
}

.loading {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  margin-top: var(--space-6);
}

.empty {
  font: var(--text-callout);
  color: var(--label-2);
}

@media (max-width: 719px) {
  .title {
    font: var(--text-title-1);
    letter-spacing: var(--tracking-title-1);
  }
}
